import React from 'react';
import Section from '../layout/Section';

/* Story section: frame motivations and trade-offs; stay candid and operator-centric. */
const StorySection: React.FC = () => {
  return (
    <Section
      kicker="Story"
      title="Why bother with yet another encryption tool?"
      body="Because encrypted storage is only useful if operators can live with it day to day — for LUKS volumes and ZFS datasets alike. LockChain leans into that tension instead of pretending it doesn't exist."
    >
      <div className="lc-grid lc-grid--2">
        <article className="lc-card">
          <h3 className="lc-card-title">Treat unlocks as workflows</h3>
          <p className="lc-card-body">
            The project champions the view that unlocking an encrypted pool or volume is a workflow,
            not a single command. There are decisions, fallbacks, retries and humans involved — all
            of which deserve explicit configuration.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Make each trade-off understood</h3>
          <p className="lc-card-body">
            LockChain does not claim to &ldquo;fix&rdquo; encryption. Instead, it makes trade-offs
            visible: what happens if the USB stick dies, how fallbacks behave across LUKS and ZFS,
            and what on-call engineers will actually see.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Focus on operators</h3>
          <p className="lc-card-body">
            Module names like <code>lockchain-cli</code>, <code>lockchain-daemon</code>,{' '}
            <code>lockchain-key-usb</code> and <code>lockchain-ui</code> reflect the intent: give
            operators more than one way to observe and steer the unlock path for both providers.
          </p>
        </article>

        <article className="lc-card">
          <h3 className="lc-card-title">Keep it honest, keep it open</h3>
          <p className="lc-card-body">
            The entire project lives on GitHub with an open configuration blueprint, console
            commands, ADRs and docs, so you can decide whether LockChain fits your risk appetite
            and achieves your security requirements.
          </p>
        </article>
      </div>
    </Section>
  );
};

export default StorySection;
